import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Color,
  Header,
  Paragraph
} from '@eggplant/pattern-library'
import { daiWebhooksPayload } from '../../docs-routes'
import type { CSSProperties } from 'react'

const popupBodyStyle: CSSProperties = {
  marginBottom: '16px',
  marginTop: '5px'
}

const WebhookBodyPayloadDescription = () =>
  <>
    <Header
      hasNoTopMargin
      rank={4}
    >
      Body payload
    </Header>
    <div style={popupBodyStyle}>
      <Paragraph>
        <Color variant='greyB'>
          The webhook uses payload parameters to represent dynamic values sent in the request payload. To construct the body payload, select the parameters from the dropdown.
        </Color>
      </Paragraph>
    </div>
    <Paragraph>
      <LinkToDocusaurus path={daiWebhooksPayload}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </Paragraph>
  </>

export default WebhookBodyPayloadDescription
